if (!customElements.get('text-read-more')) {
  class TextReadMore extends HTMLElement {
    constructor() {
      super();
      this.toggle = this.querySelector('.text-read-more__toggle');
      this.shortContent = this.querySelector('.text-read-more__short');
      this.fullContent = this.querySelector('.text-read-more__full');

      if (this.toggle) {
        this.toggle.addEventListener('click', this.handleToggle.bind(this));
      }
    }

    handleToggle(evt) {
      evt.preventDefault();

      if (this.classList.contains('is-collapsed')) {
        this.expand();
      } else {
        this.collapse();
      }
    }

    expand() {
      this.classList.remove('is-collapsed');
      this.classList.add('is-expanded');
      this.shortContent.hidden = true;
      this.fullContent.hidden = false;
      this.toggle.textContent = this.dataset.readLessText;
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    collapse() {
      this.classList.add('is-collapsed');
      this.classList.remove('is-expanded');
      this.shortContent.hidden = false;
      this.fullContent.hidden = true;
      this.toggle.textContent = this.dataset.readMoreText;
      this.toggle.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('text-read-more', TextReadMore);
}
